<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="product-list-wrap">
    <s-header :name="'商品列表'" :noback="true"></s-header>
    <div class="product-list-content">
      <header class="category-header wrap">
        <i class="nbicon nbfanhui" @click="goBack"></i>
        <div class="header-search">
          <i class="nbicon nbSearch"></i>
          <input
            type="text"
            class="search-title"
            v-model="keyword"
            placeholder="请输入查找内容"
            />
        </div>
        <span class="search-btn" @click="getSearch">搜索</span>
      </header>
      <!-- <van-tabs type="card" color="#40c4ff" @click="changeTab"  >
        <van-tab title="推荐" name=""></van-tab>
        <van-tab title="新品" name="new"></van-tab>
        <van-tab title="价格" name="price"></van-tab>
      </van-tabs> -->
    </div>
    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="product-list-refresh">
        <van-list
          v-model:loading="loading"
          :finished="finished"
          :finished-text="productList.length ? '没有更多了' : '搜索想要的商品'"
          @load="onLoad"
          @offset="10"
        >
          <!-- <p v-for="item in list" :key="item">{{ item }}</p> -->
          <template v-if="productList.length">
            <div class="product-item" v-for="(item, index) in productList" :key="index" @click="productDetail(item)">
              <img :src="$filters.prefix(item.goodsCoverImg)" />
              <div class="product-info">
                <p class="name">{{item.goodsName}}</p>
                <p class="subtitle">{{item.goodsIntro}}</p>
                <span class="price">￥ {{item.sellingPrice}}</span>
              </div>
            </div>
          </template>
          <img class="empty" v-else src="https://s.yezgea02.com/1604041313083/kesrtd.png" alt="搜索">
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs,onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { search } from '@/service/good'
import { setLocal } from '@/common/js/utils'
import { getLocal } from '@/common/js/utils'
// import md5 from 'js-md5'
import { loginJava, getListtoken } from '@/service/user'
// import sHeader from '@/components/SimpleHeader'
export default {
  setup() {
    const route = useRoute()
    const router = useRouter()
    const state = reactive({
      keyword: route.query.keyword || '',
      searchBtn: false,
      seclectActive: false,
      refreshing: false,
      list: [],
      loading: false,
      finished: false,
      productList: [],
      totalPage: 0,
      page: 1,
      orderBy: 'price'
    })

    onMounted(() => {
      // init(  )
    })

    const init = async () => {
      //获取url参数，进行storage 存储准备
      const { account , key, province, city, county, companyName,contractStatus} = route.query
      const obj = {
        user: account,
        pwd: key,
        province,
        city,
        county,
        companyName,
        contractStatus
      }
      setLocal('userData', JSON.stringify(obj))  // 将参数进行storage 存储

      const urlQuery = route.query.account
      const tokenValue = getLocal('token')
      if(urlQuery){
        
        if(tokenValue){ //有token的时候先调用java接口判断当前token是否过期
          checkToken()
        }


        const phoneNum = getLocal('phoneNum')
        if (phoneNum !== urlQuery ) { //获取本地存储手机号与url带过来的手机号不一致 ,自动登录
          autoLogin()
          /* console.log('自动登录');
          const { data } = await loginJava({
            "loginName": account,
            "passwordMd5": key,
            "province": province,
            "city": city,
            "county": county,
            "nickName": companyName
          })
          console.log(data)
          console.log('--------------')
          setLocal('token', data)
          setLocal('phoneNum', urlQuery)
          // 需要刷新页面，否则 axios.js 文件里的 token 不会被重置
          // window.location.href = '/'
          window.location.reload()
          */

        }
      }else {
        //url没urlQuery相关参数，直接获取数据
        const { categoryId } = route.query
        if (!categoryId && !state.keyword) {
          // Toast.fail('请输入关键词')
          state.finished = true
          state.loading = false;
          return
        }
        const { data, data: { list } } = await search({ pageNumber: state.page, goodsCategoryId: categoryId, keyword: state.keyword, orderBy: state.orderBy })
        
        state.productList = state.productList.concat(list)
        state.totalPage = data.totalPage
        state.loading = false;
        if (state.page >= data.totalPage) state.finished = true
      }

      
      // 原逻辑已迁移到checkToken 方法中去
      // const { categoryId } = route.query
      // if (!categoryId && !state.keyword) {
      //   // Toast.fail('请输入关键词')
      //   state.finished = true
      //   state.loading = false;
      //   return
      // }
      // const { data, data: { list } } = await search({ pageNumber: state.page, goodsCategoryId: categoryId, keyword: state.keyword, orderBy: state.orderBy })
      
      // state.productList = state.productList.concat(list)
      // state.totalPage = data.totalPage
      // state.loading = false;
      // if (state.page >= data.totalPage) state.finished = true

    }
    const goBack = () => {
      router.go(-1)
    }
    //自动登录
    async function autoLogin() {
        const urlQuery = route.query.account
        const { account , key, province, city, county, companyName, contractStatus} = route.query
        await loginJava({
          "loginName": account,
          "passwordMd5": key,
          "province": province,
          "city": city,
          "county": county,
          "nickName": companyName,
          "contractStatus": contractStatus
        }).then(async (res)=>{
          setLocal('token', res.data)
          setLocal('phoneNum', urlQuery)
          // 需要刷新页面，否则 axios.js 文件里的 token 不会被重置
          // window.location.href = '/'
          window.location.reload()

          

        })
        

    }

    // 核验token 是否过期，过期则走自动登录
    async function checkToken(){
      console.log('核验token');
      const getToken = getLocal('token')
      const { companyName,contractStatus} = route.query
      const { res } = await getListtoken({
        "token": getToken,
        "contractStatus": contractStatus,
        "nickName": companyName
      }).catch((err)=>{
          console.log(err)
          if(err.resultCode == 500){
            console.log('token过期了，走重新自动登录!')
            autoLogin()
          }
        })
      console.log(res)
      //确保登录后才请求列表接口数据
      const { categoryId } = route.query
      if (!categoryId && !state.keyword) {
        // Toast.fail('请输入关键词')
        state.finished = true
        state.loading = false;
        return
      }
      const { data, data: { list } } = await search({ pageNumber: state.page, goodsCategoryId: categoryId, keyword: state.keyword, orderBy: state.orderBy })
      
      state.productList = state.productList.concat(list)
      state.totalPage = data.totalPage
      state.loading = false;
      if (state.page >= data.totalPage) state.finished = true


    }
    const productDetail = (item) => {
      router.push({ path: `/product/${item.goodsId}` })
    }

    const getSearch = () => {
      onRefresh()
    }

    const onLoad = () => {
      if (!state.refreshing && state.page < state.totalPage) {
        state.page = state.page + 1
      }
      if (state.refreshing) {
        state.productList = [];
        state.refreshing = false;
      }
      init()
    }

    const onRefresh = () => {
      state.refreshing = true
      state.finished = false
      state.loading = true
      state.page = 1
      onLoad()
    }

    const changeTab = (name) => {
      console.log('name', name)
      state.orderBy = name
      onRefresh()
    }

    return {
      ...toRefs(state),
      goBack,
      productDetail,
      getSearch,
      changeTab,
      onLoad,
      onRefresh,
      checkToken,
      autoLogin
    }
  },
  components: {
    // sHeader
  }
}
</script>

<style lang="less" scoped>
  @import '../common/style/mixin';
  .product-list-content {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 1000;
    background: #fff;
    border-bottom: 1px solid #ebedf0;
    .category-header {
      .fj();
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      .boxSizing();
      font-size: 15px;
      color: #656771;
      z-index: 10000;
      &.active {
        background: @primary;
      }
      .icon-left {
        font-size: 25px;
        font-weight: bold;
      }
      .header-search {
        display: flex;
        width: 76%;
        height: 30px;
        line-height: 30px;
        margin: 10px 0;
        color: #232326;
        background: #F7F7F7;
        .borderRadius(20px);
        .nbSearch {
          padding: 0 5px 0 20px;
          font-size: 17px;
        }
        .search-title {
          font-size: 12px;
          height: 25px;
          color: #666;
          background: #F7F7F7;
          line-height: 28px;
        }
    }
    .icon-More {
      font-size: 20px;
    }
    .search-btn {
      height: 28px;
      margin: 8px 0;
      line-height: 28px;
      padding: 0 5px;
      color: #fff;
      background: @primary;
      .borderRadius(5px);
      margin-top: 10px;
    }
  }
}
  .content {
    height: calc(~"(100vh - 50px)");
    overflow: hidden;
    overflow-y: scroll; 
    margin-top: 50px;  // tony 于2021年7-12
  }
  .product-list-refresh {
    .product-item {
      .fj();
      width: 100%;
      height: 120px;
      padding: 10px 0;
      border-bottom: 1px solid #dcdcdc;
      img {
        width: 140px;
        height: 120px;
        padding: 0 10px;
        .boxSizing();
      }
      .product-info {
          width: 56%;
          height: 120px;
          padding: 5px;
          text-align: left;
          .boxSizing();
          p {
            margin: 0
          }
          .name {
            width: 100%;
            max-height: 40px;
            line-height: 20px;
            font-size: 15px;
            color: #333;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .subtitle {
            width: 100%;
            max-height: 20px;
            padding: 10px 0;
            line-height: 25px;
            font-size: 13px;
            color: #999;
            overflow: hidden;
          }
          .price {
            color: red;
            font-size: 16px;
          }
      }
  }
  .empty {
    display: block;
    width: 150px;
    margin: 50px auto 20px;
  }
}
</style>
